import CommonService from "@/domain/dataTable/commonService/CommonService.js";
export default class EmpresaService extends CommonService {
    constructor(http) {
        super(http);
    }

    getEmpresasNotAdmin(idConta, page, qntd, range, ) {

        let url = `contas/emprs/noAdmin/${idConta}?_page=${page}&_pagesize=${qntd}`;
        return this._resource.get(url).then(success => {
            return success.body;
        },
            failed => {
                return failed;
            });
    }

    getEmpresasConta(idConta, page, qntd, range, ) {
        
        let url = `contas/info/${idConta}?_page=${page}&_pagesize=${qntd}`;

        return this._resource.get(url).then(async success => {
            let notAdmin = await this.getEmpresasNotAdmin(idConta)
            success.body['emprs_not_admin'] = notAdmin;
            return success.body;
        },
            failed => {
                return failed;
            });
    }
    getEmpresasColaborador(idColaborador, page, qntd, range, ) {

        let url = `contas/colaborador/${idColaborador}?_page=${page}&_pagesize=${qntd}`;

        return this._resource.get(url).then(success => {
            return success.body;
        },
            failed => {
                return failed;
            });
    }

    getEmpresasCnpj(cnpj) {
        let url = `empresas?cnpj=${cnpj}`;
        // this.resource = this.$resource("empresas?cnpj=" + this.empresa.cnpj);
        return this._resource.get(url).then(
            success => {
                //trocar para algo melhor
                //trocar até aqui
                return success;
            },
            failed => {
                if (failed.status == 404) {
                    return failed;
                }
            }
        );
    }
    getEmpresasID(id) {
        let url = `empresas/${id}`;
        return this._resource.get(url).then(
            success => {
                //trocar para algo melhor
                //trocar até aqui
                return success.body;
            },
            failed => {
                return failed;
            }
        );
    }
    getAPIReceita(cnpj) {
        let url = `"https://www.receitaws.com.br/v1/cnpj/${cnpj}`;
        return this._resource
            .jsonp("https://www.receitaws.com.br/v1/cnpj/" + cnpj)
            .then(
                success => {
                    return success;
                },
                failed => {
                    return failed;
                }
            );
    }
    cadastrar(empresa, idConta) {


        let url = `contas/empresa/${idConta}`;

        let body = JSON.stringify(empresa);
        return this._resource.post(url, body).then(success => {
            success['infoMessage'] = { msg: 'Empresa cadastrada com sucesso.', ok: true }
            return success;
        }, failed => {

            failed['infoMessage'] = { msg: 'Não conseguimos cadastrar a empresa.', ok: false }
            return failed;
        })
    }
    faturamento(idConta, idEmpresa) {
        let url = `contas/empresa/faturamento/${idConta}`;
        let body = {};
        body['faturamento'] = idEmpresa;
        body = JSON.stringify(body);
        return this._resource.post(url, body).then(success => {
            return true;
        }, failed => {
            return false;
        })
    }
    editar(empresa, idEmpresa) {
        let url = `empresas/${idEmpresa}`;

        let body = JSON.stringify(empresa);

        return this._resource.patch(url, body).then(success => {

            success['infoMessage'] = { msg: 'As informações da empresa foram editadas.', ok: true }
            return success;
        }, failed => {

            failed['infoMessage'] = { msg: 'Não conseguimos editar as informações da empresa.', ok: false }
            return failed;
        })
    }

    fechamentoMensal(body) {
        let url = `empresas/fechamentoMensal`

        let bodyEnvio = JSON.stringify(body);
        return this._resource.post(url, bodyEnvio).then(success => {
            return success;
        }, failed => {
            return failed;
        })
    }


}


// WEBPACK FOOTER //
// ./src/domain/conta/empresa/EmpresaService.js